export default __webpack_public_path__ + "static/media/share-2.356307b4.svg";